import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IfFeatureDirective, IfRoleDirective } from '@nk/access-block';
import { CompanyFlagIconComponent } from '@nk/company-block';
import { PersonFlagIconComponent } from '@nk/person-block';
import { RiskLevelModule } from '@nk/shared/components/risk-level/risk-level.module';
import {
  ButtonDirective,
  CardComponent,
  CardContentComponent,
  CardFooterComponent,
  CardHeaderComponent,
  CheckboxComponent,
  DiagramGraphComponent,
  SpinnerComponent,
  UploadFileComponent,
} from '@nk/ui-lib';
import { HighchartsChartModule } from 'highcharts-angular';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { AdvancedSearchHelpTextComponent } from './components/advanced-search-help-text/advanced-search-help-text.component';
import { DismissableAlertMessageComponent } from '@nk/ui-lib';
import { HighchartsComponent } from './components/charts/highcharts/highcharts.component';
import { HighmapComponent } from './components/charts/highmap/highmap.component';
import { FormSelectComponent } from './components/form/form-select/form-select.component';
import { LoadingModalComponent } from './components/loading-modal/loading-modal.component';
import { RiskPasswordResetLinkComponent } from './components/move-these-components/risk-password-reset-link/risk-password-reset-link.component';
import { NestedCheckboxSidebarComponent } from './components/nested-checkbox-sidebar/nested-checkbox-sidebar.component';
import { RadioButtonComponent } from './components/radio-button/radio-button.component';
import { SubscriptionWarningComponent } from './components/subscription-warning/subscription-warning.component';
import { SuccessModal } from './components/success-modal/success-modal.component';
import { WizardFooterComponent } from './components/wizard/wizard-footer/wizard-footer.component';
import { WizardPageComponent } from './components/wizard/wizard-page/wizard-page.component';
import { WizardComponent } from './components/wizard/wizard/wizard.component';
import { BindHeightToDirective } from './directives/bind-height-to/bind-height-to.directive';
import { FocusDirective } from './directives/focus.directive';
import { SetFocusDirective } from './directives/set-focus.directive';
import { TrackCapslockDirective } from './directives/track-capslock.directive';
import { OwnershipTextComponent } from './ownership-text/ownership-text.component';
import { PipeUtilsModule } from './pipes/pipe-utils.module';

@NgModule({
  imports: [
    CommonModule,
    TypeaheadModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    HighchartsChartModule,
    TooltipModule,
    TranslateModule,
    RouterModule,
    PipeUtilsModule,
    PopoverModule,
    RiskLevelModule,
    CardComponent,
    CardContentComponent,
    CardFooterComponent,
    CardHeaderComponent,
    SpinnerComponent,
    CompanyFlagIconComponent,
    PersonFlagIconComponent,
    ButtonDirective,
    CheckboxComponent,
    IfFeatureDirective,
    IfRoleDirective,
    UploadFileComponent,
    DismissableAlertMessageComponent,
    DiagramGraphComponent,
  ],
  declarations: [
    // ! REMEMBER to also export them
    FocusDirective,
    SetFocusDirective,
    RiskPasswordResetLinkComponent,
    NestedCheckboxSidebarComponent,
    LoadingModalComponent,
    WizardComponent,
    WizardPageComponent,
    WizardFooterComponent,
    FormSelectComponent,
    HighmapComponent,
    HighchartsComponent,
    SuccessModal,
    SubscriptionWarningComponent,
    RadioButtonComponent,
    TrackCapslockDirective,
    OwnershipTextComponent,
    BindHeightToDirective,
    AdvancedSearchHelpTextComponent,
  ],
  exports: [
    // ????
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    TranslateModule,
    CheckboxComponent,
    IfFeatureDirective,
    IfRoleDirective,
    // ????
    CardComponent,
    CardContentComponent,
    CardFooterComponent,
    CardHeaderComponent,
    CompanyFlagIconComponent,
    WizardComponent,
    WizardPageComponent,
    WizardFooterComponent,
    DiagramGraphComponent,
    RiskPasswordResetLinkComponent,
    SetFocusDirective,
    UploadFileComponent,
    HighmapComponent,
    FormSelectComponent,
    NestedCheckboxSidebarComponent,
    LoadingModalComponent,
    SuccessModal,
    SubscriptionWarningComponent,
    RadioButtonComponent,
    TrackCapslockDirective,
    OwnershipTextComponent,
    PersonFlagIconComponent,
    BindHeightToDirective,
    DismissableAlertMessageComponent,
    AdvancedSearchHelpTextComponent,
  ],
})
export class SharedModule {}
